export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12167.8c3c9e81.jpg";